

export class AppSettings {

    public static API_ENDPOINT = 'https://vitalinsightsapi.azurewebsites.net/api/';

    public static VITAL_INSIGHTS_PUBLISHED_URL = 'https://vitalinsightsweb.azurewebsites.net/';

    public static LIS_IP_Address = '192.168.168.33';

    public static GET_CORE_AUTH_SESSIONTOKEN_URL = 'https://coreutilities.azurewebsites.net/';


}